import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Benefits.scss';// to import local scss fle

const Benefits = () => (
  <div className={cn('row', styles.benefitsContainer)}>
    <div className={cn('col s12', styles.desc)}>
      <h1>BENEFITS OF MYRECRUITBOARD</h1>
      <div className={cn('col s12 m6', styles.halfList)}>
        <ul>
          <li><div className={styles.redDot} />Affordable.</li>
          <li><div className={styles.redDot} />Easy to use. </li>
          <li><div className={styles.redDot} />
            High success rates.
            </li>
          <li>
            <div className={styles.redDot} />
            We will find a college for you.
            </li>
          <li>
            <div className={styles.redDot} />
            Instant college and coach matches.
            </li>
        </ul>
      </div>
      <div className={cn('col s12 m6', styles.halfList)}>
        <ul>
          <li><div className={styles.redDot} />Direct contact with college coaches.</li>
          <li><div className={styles.redDot} />
            Data driven results specifically formulated for each individual.
          </li>
          <li><div className={styles.redDot} />
            Largest football only recruiting Twitter account.
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/components/Benefits/Benefits.js